export const ROLE_CYBERINT = 'cyberint';
export const ROLE_DEMO = 'argos-demo';
export const ROLE_RETAIL = 'retail';
export const ROLE_SINGTEL = 'singtel';
export const ROLE_SOFTBANK = 'softbank';
export const ROLE_TOYOTA = 'toyota';
export const ROLE_NOVARTIS = 'novartis';
export const ROLE_ASOS = 'asos';
export const ROLE_BARCLAYS = 'barclays';
export const ROLE_SKYSCANNER = 'skyscanner';
export const ROLE_RSA_2019 = 'rsa-2019';
